import api from '@/api';
import { mapActions } from 'vuex';
import Context from '@/models/Context';
import authenticator from '@/authenticator/password';
import User from '@/models/core/User';
import Card from '@/components/Card/Card';
import Input from '@/components/Input/Input';
import Button from '@/components/Button/Button';
import ToastWrapper from '@/components/ToastWrapper/ToastWrapper';

export default {
  name: 'login',
  components: {
    Card,
    Input,
    Button,
    ToastWrapper
  },
  props: [],
  data() {
    return {
      email: '',
      password: '',
      password_confirmation: '',
      isRunning: false
    };
  },
  computed: {
    confirmToken: function() {
      return this.$route.query.token;
    },

    isValid: function() {
      return this.password_confirmation.length > 4
        ? this.password === this.password_confirmation
        : false;
    },

    isDisabled: function() {
      return this.isRunning || !this.isValid;
    }
  },
  created() {
    if (!this.confirmToken) {
      this.$router.push({ path: '/login' });
    }
  },
  mounted() {},
  methods: {
    ...mapActions({
      _newToast: 'toasts/_addToast'
    }),
    login(e, username, password) {
      e.preventDefault();

      this.isRunning = true;

      const domain = Context.query()
        .where(context => {
          context.id === 'current';
        })
        .first().domain;

      api
        .post(`${domain}/reset/confirm`, {
          token: this.confirmToken,
          password: this.password
        })
        .then(() => {
          this._newToast({
            text:
              'Your password has been updated successfully, you will be redirected to the login page',
            variant: 'good',
            duration: 3000
          });

          setTimeout(() => {
            this.$router.push({ path: '/login' });
          }, 3000);
        })
        .catch(error => {
          this._newToast({
            text: 'An error occured while trying to make the request',
            variant: 'danger',
            duration: 2000
          });
        });

      // authenticator
      //   .login({ username, password })
      //   .then(() => {
      //     const getUser = new Promise(resolve => {
      //       this._getUser().then(() => {
      //         resolve();
      //       });
      //     });

      //     return getUser;
      //   })
      //   .then(() => {
      //     this.$router.push({ path: '/admin' });
      //   })
      //   .catch(error => {
      //     this._newToast({
      //       text: 'An error occured while trying to login, so you know',
      //       variant: 'danger',
      //       duration: 2000
      //     });
      //   })
      //   .finally(() => {
      //     this.isRunning = false;
      //   });
    }
  }
};
